import { render, staticRenderFns } from "./UserSettingsSecrets.vue?vue&type=template&id=662643c2&"
import script from "./UserSettingsSecrets.vue?vue&type=script&lang=js&"
export * from "./UserSettingsSecrets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports